<div class="wrapper">
  <div class="note-type text-type-6">{{ data?.note_type }}</div>
  <div class="description text-type-10">{{ data?.description }}</div>
</div>
